/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hplc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transfer an HPLC method between columns of different sizes while keeping the separation equivalent. Enter both column geometries and your original method to get the scaled flow, injection volume and gradient time.`)
};

const es_hplc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transfiere un método HPLC entre columnas de tamaños distintos manteniendo la separación equivalente. Introduce ambas geometrías de columna y tu método original para obtener el flujo, el volumen de inyección y el tiempo de gradiente escalados.`)
};

const de_hplc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übertragen Sie eine HPLC-Methode zwischen unterschiedlich dimensionierten Säulen bei gleichwertiger Trennung. Geben Sie beide Säulengeometrien und Ihre ursprüngliche Methode ein, um skalierten Fluss, Injektionsvolumen und Gradientenzeit zu erhalten.`)
};

const nl_hplc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zet een HPLC-methode over tussen kolommen van verschillende afmetingen met behoud van een gelijkwaardige scheiding. Voer beide kolomgeometrieën en uw oorspronkelijke methode in om de geschaalde flow, het injectievolume en de gradiënttijd te berekenen.`)
};

const fr_hplc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transférez une méthode HPLC entre colonnes de tailles différentes tout en conservant une séparation équivalente. Entrez les deux géométries de colonne et votre méthode d'origine pour obtenir le débit, le volume d'injection et le temps de gradient adaptés.`)
};

const it_hplc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasferisci un metodo HPLC tra colonne di dimensioni diverse mantenendo la separazione equivalente. Inserisci entrambe le geometrie di colonna e il tuo metodo originale per ottenere il flusso, il volume di iniezione e il tempo di gradiente scalati.`)
};

const pt_br2_hplc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transfira um método de HPLC entre colunas de tamanhos diferentes mantendo a separação equivalente. Informe as duas geometrias de coluna e seu método original para obter o fluxo, o volume de injeção e o tempo de gradiente dimensionados.`)
};

const pt_hplc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transfira um método de HPLC entre colunas de tamanhos diferentes mantendo a separação equivalente. Introduza ambas as geometrias de coluna e o método original para obter o caudal, o volume de injeção e o tempo de gradiente escalados.`)
};

const ja_hplc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分離能を同等に保ちながら、異なるサイズのカラム間でHPLCメソッドを移行します。両方のカラム形状と元のメソッドを入力すると、スケーリングされた流速、注入量、グラジエント時間が求められます。`)
};

const zh_hplc_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在保持分离效果等效的前提下，将 HPLC 方法在不同尺寸的色谱柱之间转移。输入两种色谱柱的几何参数及原方法，即可得到换算后的流速、进样量和梯度时间。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hplc_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hplc_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hplc_intro", locale)
	if (locale === "en") return en_hplc_intro(inputs)
	if (locale === "es") return es_hplc_intro(inputs)
	if (locale === "de") return de_hplc_intro(inputs)
	if (locale === "nl") return nl_hplc_intro(inputs)
	if (locale === "fr") return fr_hplc_intro(inputs)
	if (locale === "it") return it_hplc_intro(inputs)
	if (locale === "pt-BR") return pt_br2_hplc_intro(inputs)
	if (locale === "pt") return pt_hplc_intro(inputs)
	if (locale === "ja") return ja_hplc_intro(inputs)
	return zh_hplc_intro(inputs)
};